export default {
  common: {
    clearAll: 'Alles Wissen',
    restart: 'Herstarten'
  },
  download: {
    bodyText: 'Klik op de onderstaande link om %{products} te downloaden',
    bothProducts: 'PlayBase en/of Nexus',
    bodyTextFromAcceptInvitation:
      'Het proces zal enige tijd in beslag nemen. Ondertussen kun je Metrica Sports blijven gebruiken zoals gewoonlijk.',
    bodyTextFromDeclineInvitation:
      'Je hebt de uitnodiging afgewezen! Klik op de onderstaande link om %{products} te downloaden',
    bodyTextFromTrial:
      'Welkom bij je proefperiode! Controleer je geregistreerde e-mail voor een verificatielink (controleer de spammap).',
    bodyTitle: 'Downloaden',
    bodyTitleFromAcceptInvitation: 'We zijn je account aan het wijzigen',
    bodyTitleFromDeclineInvitation: 'Uitnodiging Geweigerd',
    bodyTitleFromTrial: 'Registratie compleet',
    play2: {
      description:
        'Metrica PlayBase is een intuïtieve analyse tool ontworpen voor amateur- en prosumer coaches, kleine clubs en onafhankelijke analisten. Het vereenvoudigt het proces van prestatiebeoordeling, waardoor het toegankelijk wordt voor iedereen.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'Metrica Nexus is ontworpen voor elite-analisten en coaches die op zoek zijn naar uitgebreide inzichten in prestaties. Met geavanceerde tools binnen handbereik, kun je teamstrategieën verbeteren en succes behalen.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      'Bedankt voor je registratie bij Metrica Sports! Om te beginnen met je proefversie, download %{products}.'
  },
  error: {
    restart:
      'Het lijkt erop dat je ergens in probeert te komen wat we nog aan het ontwikkelen zijn...',
    tryAgainMsg:
      'Probeer het opnieuw. Als deze fout zich blijft voordoen, neem dan contact op met het Metrica Sports support-team'
  },
  verifyEmail: {
    generateLink: 'Genereer een nieuwe link door in te loggen in Play',
    readyToLogin: 'Je bent klaar om in te loggen bij Play',
    successfully: 'E-mail succesvol geverifieerd',
    unsuccessfully: 'Fout bij e-mailverificatie, ongeldig token'
  }
}
